module.exports = __webpack_public_path__ + "static/img/xtWZ.527f45ac.png";